import { createI18n } from "vue-i18n";

const messages = {
  cn: {
    // 菜单分组标题
    lottery_center: '抽赏中心',
    product_center: '商品中心',
    mall_management: '商城管理',
    finance_management: '财务管理',
    data_rankings: '数据排名',
    system_settings: '系统设置',
    deliver_note: '发货须知',
    shipping_fee_config: '运费配置',
    settlement_pause: '结算暂停管理',
    excluded_gain_categories: '排除盈亏目录',
    eat_cook_categories: "吃菜/做菜统计目录",

    // 原有菜单项
    events: '活动管理',
    card_records: '明信片排名管理',
    box_records: '抽赏记录管理',
    gift_records: '赠送记录管理',
    water_items: '流水排名管理',
    loser_items: '非酋排名管理',
    asset_loser_items: '资产法盈亏排行',
    profit_records: '盈亏记录管理',
    banners: "轮播图管理",
    product_brands: "品牌管理",
    ips: "IP管理",
    compound_categories: "合成分类",
    compound_category_new: "新建合成分类",
    compound_category_edit: "编辑合成分类",
    compounds: "合成管理",
    compound_records: "合成记录",
    products: "商品管理",
    product_edit: '商品编辑',
    mall_products: "商城商品",
    mall_orders: "商城订单",
    mall_order_edit: "订单详情",
    mall_coupons: "商城优惠券",
    mall_coupon_new: "新建优惠券",
    mall_coupon_edit: "编辑优惠券",
    mall_coupon_usage: "使用情况",
    lottery_coupons: "抽赏优惠券",
    lottery_coupon_new: "新建抽赏优惠券",
    lottery_coupon_edit: "编辑抽赏优惠券",
    lottery_coupon_usage: "抽赏优惠券使用情况",
    lottery_signs: "抽签签池",
    lottery_sign_new: "新增签",
    lottery_sign_edit: "编辑签",
    postcard_rewards: "明信片奖励",
    postcard_reward_configs: "奖励配置",
    postcard_reward_config_new: "新建奖励配置",
    postcard_reward_config_edit: "编辑奖励配置",
    postcard_reward_logs: "发放记录",
    card_draw_system: "抽卡系统",
    card_series: "卡牌系列",
    card_series_new: "新建卡牌系列",
    card_series_edit: "编辑卡牌系列",
    card_rarities: "稀有度管理",
    card_rarities_new: "新建稀有度",
    card_rarities_edit: "编辑稀有度",
    card_languages: "语系管理",
    card_languages_new: "新建语系",
    card_languages_edit: "编辑语系",
    card_versions: "版本管理",
    card_versions_new: "新建版本",
    card_versions_edit: "编辑版本",
    cards_management: "卡牌管理",
    cards_management_new: "新建卡牌",
    cards_management_edit: "编辑卡牌",
    card_pools: "卡池管理",
    card_pools_new: "新建卡池",
    card_pools_edit: "编辑卡池",
    card_draw_records: "抽卡记录",
    // 对对碰系统
    match_game_system: "对对碰系统",
    match_pools: "池子管理",
    match_pools_new: "新建池子",
    match_pools_edit: "编辑池子",
    match_pools_stats: "池子统计",
    match_game_records: "游戏记录",
    match_game_record_detail: "记录详情",
    run_gift_records: "冲冲赏记录",
    product_gift_records: "吃菜/做菜记录",
    box_categories: "目录管理",
    box_infos: "套系管理",
    members: "用户管理",
    admins: "管理员管理",
    distributions: "分销管理",
    payment_records: '微信支付管理',
    add_balance_records: `${(window as any).__CONFIG__?.BALANCE_LABEL || '探玩币'}管理`,
    add_point_records: `${(window as any).__CONFIG__?.POINT_LABEL || '探玩石'}管理`,
    add_extra_point_records: '军粮管理',
    remove_balance_records: '提现管理',

    pending_events: "活动审核",
    dashboard: "数据统计",
    business_districts: "商圈列表",
    coupon_items: "券种配置",
    coupon_deliver_events: "放券与增发",
    coupon_rule: "领用规则",
    budgets: "预算设定",
    coupon_deliver_rules: "领用规则",
    shops: "夥伴列表",
    coupon_management: "消费券管理",
    event_management: "活动管理",
    coupon_basic: "基础配置",
    coupon_pre_deliver_setting: "预发配置",
    coupon_request_rule: "领取规则",
    coupon_increase_records: "增发日志",
    announcements: "公告管理",
    orders: "订单管理",
    system_settings_admins: "管理员管理",
    system_settings_shop_banners: "商户端轮播图管理",
    system_settings_user_banners: "用户端轮播图管理",
    news_items: "新闻管理",
    system_settings_users: "用户管理",
    system_settings_roles: "角色管理",
    system_settings_opration_record: "系统操作日志",
    layoutBuilder: "Layout builder",
    craft: "Crafted",
    pages: "Pages",
    profile: "Profile",
    profileOverview: "Overview",
    projects: "Projects",
    campaigns: "Campaigns",
    documents: "Documents",
    connections: "Connections",
    wizards: "Wizards",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Account",
    accountOverview: "Overview",
    settings: "Settings",
    authentication: "Authentication",
    basicFlow: "Basic Flow",
    signIn: "Sign-in",
    signUp: "Sign-up",
    passwordReset: "Password Reset",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Apps",
    chat: "Chat",
    privateChat: "Private Chat",
    groupChat: "Group Chat",
    drawerChat: "Drawer Chat",
    widgets: "Widgets",
    widgetsLists: "Lists",
    widgetsStatistics: "Statistics",
    widgetsCharts: "Charts",
    widgetsMixed: "Mixed",
    widgetsTables: "Tables",
    widgetsFeeds: "Feeds",
    changelog: "Changelog",
    docsAndComponents: "Docs & Components",
    megaMenu: "Mega Menu",
    exampleLink: "Example link",
    modals: "Modals",
    general: "General",
    inviteFriends: "Invite Friends",
    viewUsers: "View Users",
    upgradePlan: "Upgrade Plan",
    shareAndEarn: "Share & Earn",
    forms: "Forms",
    newTarget: "New Target",
    newCard: "New Card",
    newAddress: "New Address",
    createAPIKey: "Create API Key",
    twoFactorAuth: "Two Factor Auth",
    createApp: "Create App",
    createAccount: "Create Account",
    documentation: "Documentation",
    components: "Components",
    resources: "Resources",
    activity: "Activity",
    customers: "Customers",
    gettingStarted: "Getting Started",
    customersListing: "Customers Listing",
    customerDetails: "Customers Details",
    calendarApp: "Calendar",
    subscriptions: "Subscriptions",
    getStarted: "Getting Started",
    subscriptionList: "Subscription List",
    addSubscription: "Add Subscription",
    viewSubscription: "View Subscription",
    shipping_management: "发货管理",
    shipping_orders: "发货单管理",
    shipping_products: "发货商品管理",
    shipping_records: "发货记录",
    all_status: "所有状态",
    pending: "待处理",
    processing: "处理中", 
    completed: "已完成",
    all_purchased: "全部采购状态",
    purchased: "已采购",
    not_purchased: "未采购",
    product_name: "商品名称",
    shipping_order: "发货订单",
    shipping_status: "发货状态",
    purchase_price: "采购价格",
    shipping_no: "快递单号",
    deliver: "已发货",
    search_product: "搜索商品名称",
    search_user_mobile: "搜索用户手机号",
    search: "搜索",
    please_input_shipping_provider: "请输入快递供应商",
    please_input_shipping_no: "请输入快递单号",
    batch_deliver: "批量发货",
    confirm: "确认",
    cancel: "取消",
    delivered: "已发货",
    shipping_provider: "快递供应商",
    deliver_success: "发货成功",
    deliver_fail: "发货失败",
    shipping_provider_required: "请输入快递供应商",
    shipping_no_required: "请输入快递单号",
    different_address_error: "所选商品必须属于同一个收货地址",
    delivered_error: "选中商品中包含已发货商品",
    unpurchased_error: "选中商品中包含未采购或采购价为空的商品",
    pocket_items: "用户背包",
    available: "可用",
    used: "已使用",
    user_nickname: "用户昵称",
    user_mobile: "用户手机号",
    product_recycle_price: "商品回收价",
    status: "状态",
    created_at: "创建时间",
    total: "总计",
    items_per_page: "每页条数",
    goto: "前往",
    page: "页",
    waiting_for_deliver: "待发货",
    recycle: "已回收",
    opened: "已开启",
    abandoned: "已废弃",
    compounded: "已合成",
    user_management: "用户管理",
    count: "数量",
    shipping_record_columns: {
      id: 'ID',
      user_nickname: '用户昵称',
      user_mobile: '用户手机号',
      name: '收件人',
      mobile: '手机号',
      area: '地区',
      address_detail: '详细地址',
      shipping_provider: '快递公司',
      shipping_no: '快递单号',
      created_at: '创建时间',
      created_by: '创建人',
      products: '商品信息',
      product_name: '商品名称',
      purchase_price: '采购价格',
      quantity: '数量'
    },
    update_success: "更新成功",
    update_fail: "更新失败",
    download_fail: "下载失败",
    please_select_date_range: "请先选择日期范围(不超过 {days} 天)再下载",
    date_range_too_large: "日期范围不能超过 {days} 天,请缩小范围",
    confirm_cancel: '确认取消该发货商品?',
    cancel_success: '取消成功',
    cancel_fail: '取消失败',
    cancelled: "已取消",
    download_excel: "下载Excel",
    note: '备注',
    input_note: '请输入备注',
    confirm_return: '确认退回该发货记录?',
    return_success: '退回成功',
    return_fail: '退回失败',
    batch_operation: '批量操作',
    search_by_mobile: '通过手机号搜索',
    user_pending_products: '用户待发货商品',
    total_product_types: '商品种类数',
    total_quantity: '总数量',
    select_operation: '选择操作',
    mark_as_purchased: '设为已采购',
    cancel_shipping: '取消发货',
    deliver_shipping: '发货',
    operation_type: '操作类型',
    selected_products: '已选商品',
    please_select_products: '请选择要操作的商品',
    please_select_operation: '请选择操作类型',
    operation_success: '操作成功',
    operation_failed: '操作失败',
    no_pending_products: '该用户暂无待发货商品',
    search_user_products: '搜索用户商品',
    search_mobile_placeholder: '请输入用户手机号',
    search_products: '搜索商品',
    product_details: '商品详情',
    recipient_info: '收件人信息',
    recipient_name: '收件人姓名',
    recipient_mobile: '收件人手机',
    deliver_same_address_only: '发货只能选择同一收货地址的商品，请分开操作',
    please_input_user_mobile: '请输入用户手机号',
    search_failed: '搜索失败',
  },
  en: {
    // Menu group titles
    lottery_center: 'Lottery Center',
    product_center: 'Product Center',
    mall_management: 'Mall Management',
    finance_management: 'Finance Management',
    data_rankings: 'Data Rankings',
    system_settings: 'System Settings',
    deliver_note: 'Shipping Notice',
    shipping_fee_config: 'Shipping Fee Config',
    settlement_pause: 'Settlement Pause',
    excluded_gain_categories: 'Excluded Gain Categories',
    eat_cook_categories: "Eat/Cook Stat Categories",

    dashboard: "Dashboard",
    profit_records: "Profit Records",
    compound_categories: "Compound Categories",
    compound_category_new: "New Compound Category",
    compound_category_edit: "Edit Compound Category",
    compound_records: "Compound Records",
    mall_products: "Mall Products",
    mall_orders: "Mall Orders",
    mall_order_edit: "Order Details",
    mall_coupons: "Mall Coupons",
    mall_coupon_new: "New Coupon",
    mall_coupon_edit: "Edit Coupon",
    mall_coupon_usage: "Usage Details",
    lottery_coupons: "Lottery Coupons",
    lottery_coupon_new: "New Lottery Coupon",
    lottery_coupon_edit: "Edit Lottery Coupon",
    lottery_coupon_usage: "Lottery Coupon Usage",
    lottery_signs: "Lottery Signs",
    lottery_sign_new: "New Lottery Sign",
    lottery_sign_edit: "Edit Lottery Sign",
    postcard_rewards: "Postcard Rewards",
    postcard_reward_configs: "Reward Configs",
    postcard_reward_config_new: "New Reward Config",
    postcard_reward_config_edit: "Edit Reward Config",
    postcard_reward_logs: "Distribution Logs",
    card_draw_system: "Card Draw System",
    card_series: "Card Series",
    card_series_new: "New Card Series",
    card_series_edit: "Edit Card Series",
    card_rarities: "Card Rarities",
    card_rarities_new: "New Card Rarity",
    card_rarities_edit: "Edit Card Rarity",
    card_languages: "Card Languages",
    card_languages_new: "New Card Language",
    card_languages_edit: "Edit Card Language",
    card_versions: "Card Versions",
    card_versions_new: "New Card Version",
    card_versions_edit: "Edit Card Version",
    cards_management: "Cards Management",
    cards_management_new: "New Card",
    cards_management_edit: "Edit Card",
    card_pools: "Card Pools",
    card_pools_new: "New Card Pool",
    card_pools_edit: "Edit Card Pool",
    card_draw_records: "Draw Records",
    // Match Game System
    match_game_system: "Match Game System",
    match_pools: "Match Pools",
    match_pools_new: "New Match Pool",
    match_pools_edit: "Edit Match Pool",
    match_pools_stats: "Pool Statistics",
    match_game_records: "Game Records",
    match_game_record_detail: "Record Detail",
    run_gift_records: "Run Gift Records",
    product_gift_records: "Eat/Cook Records",
    asset_loser_items: 'Asset P&L Ranking',
    layoutBuilder: "Layout builder",
    craft: "Crafted",
    pages: "Pages",
    profile: "Profile",
    profileOverview: "Overview",
    projects: "Projects",
    campaigns: "Campaigns",
    documents: "Documents",
    connections: "Connections",
    wizards: "Wizards",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Account",
    accountOverview: "Overview",
    settings: "Settings",
    authentication: "Authentication",
    basicFlow: "Basic Flow",
    signIn: "Sign-in",
    signUp: "Sign-up",
    passwordReset: "Password Reset",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Apps",
    chat: "Chat",
    privateChat: "Private Chat",
    groupChat: "Group Chat",
    drawerChat: "Drawer Chat",
    widgets: "Widgets",
    widgetsLists: "Lists",
    widgetsStatistics: "Statistics",
    widgetsCharts: "Charts",
    widgetsMixed: "Mixed",
    widgetsTables: "Tables",
    widgetsFeeds: "Feeds",
    changelog: "Changelog",
    docsAndComponents: "Docs & Components",
    megaMenu: "Mega Menu",
    exampleLink: "Example link",
    modals: "Modals",
    general: "General",
    inviteFriends: "Invite Friends",
    viewUsers: "View Users",
    upgradePlan: "Upgrade Plan",
    shareAndEarn: "Share & Earn",
    forms: "Forms",
    newTarget: "New Target",
    newCard: "New Card",
    newAddress: "New Address",
    createAPIKey: "Create API Key",
    twoFactorAuth: "Two Factor Auth",
    createApp: "Create App",
    createAccount: "Create Account",
    documentation: "Documentation",
    components: "Components",
    resources: "Resources",
    activity: "Activity",
    customers: "Customers",
    gettingStarted: "Getting Started",
    customersListing: "Customers Listing",
    customerDetails: "Customers Details",
    calendarApp: "Calendar",
    subscriptions: "Subscriptions",
    getStarted: "Getting Started",
    subscriptionList: "Subscription List",
    addSubscription: "Add Subscription",
    viewSubscription: "View Subscription",
    shipping_management: "Shipping Management",
    shipping_orders: "Shipping Orders",
    shipping_products: "Shipping Products",
    shipping_records: "Shipping Records",
    pending: "Pending",
    deliver: "Delivered",
    search_product: "Search Product Name",
    search_user_mobile: "Search User Mobile",
    search: "Search",
    please_input_shipping_provider: "Please input shipping provider",
    please_input_shipping_no: "Please input shipping number",
    batch_deliver: "Batch Deliver",
    confirm: "Confirm",
    cancel: "Cancel",
    delivered: "Delivered",
    shipping_provider: "Shipping Provider",
    shipping_no: "Shipping No.",
    deliver_success: "Deliver Success",
    deliver_fail: "Deliver Failed",
    shipping_provider_required: "Shipping provider is required",
    shipping_no_required: "Shipping number is required",
    different_address_error: "Selected items must have the same shipping address",
    delivered_error: "Selected items contain delivered items",
    unpurchased_error: "Selected items contain unpurchased or empty price items",
    pocket_items: "User Pocket",
    available: "Available",
    used: "Used",
    user_nickname: "User Nickname",
    user_mobile: "User Mobile",
    product_name: "Product Name",
    product_recycle_price: "Product Recycle Price",
    status: "Status",
    created_at: "Created At",
    total: "Total",
    items_per_page: "Items per page",
    goto: "Goto",
    page: "Page",
    waiting_for_deliver: "Waiting for deliver",
    recycle: "Recycled",
    opened: "Opened",
    abandoned: "Abandoned",
    compounded: "Compounded",
    user_management: "User Management",
    members: "User List",
    all_status: "All Status",
    count: "Count",
    shipping_record_columns: {
      id: 'ID',
      user_nickname: 'User Nickname',
      user_mobile: 'User Mobile',
      name: 'Recipient',
      mobile: 'Mobile',
      area: 'Area',
      address_detail: 'Address Detail',
      shipping_provider: 'Shipping Provider',
      shipping_no: 'Shipping No.',
      created_at: 'Created At',
      created_by: 'Created By',
      products: '商品信息',
      product_name: '商品名称',
      purchase_price: '采购价格',
      quantity: '数量'
    },
    update_success: "Update Success",
    update_fail: "Update Failed",
    download_fail: "Download Failed",
    please_select_date_range: "Please select a date range (within {days} days) before downloading",
    date_range_too_large: "Date range cannot exceed {days} days, please narrow it",
    confirm_cancel: 'Are you sure to cancel this shipping product?',
    cancel_success: 'Cancelled successfully',
    cancel_fail: 'Cancel failed',
    cancelled: "Cancelled",
    note: 'Note',
    input_note: 'Please input note',
    confirm_return: 'Are you sure to return this shipping record?',
    return_success: 'Returned successfully',
    return_fail: 'Return failed',
    batch_operation: 'Batch Operation',
    search_by_mobile: 'Search by Mobile',
    user_pending_products: 'User Pending Products',
    total_product_types: 'Total Product Types',
    total_quantity: 'Total Quantity',
    select_operation: 'Select Operation',
    mark_as_purchased: 'Mark as Purchased',
    cancel_shipping: 'Cancel Shipping',
    deliver_shipping: 'Deliver Shipping',
    operation_type: 'Operation Type',
    selected_products: 'Selected Products',
    please_select_products: 'Please select products to operate',
    please_select_operation: 'Please select operation type',
    operation_success: 'Operation Success',
    operation_failed: 'Operation failed',
    no_pending_products: 'No Pending Products for This User',
    search_user_products: 'Search User Products',
    search_mobile_placeholder: 'Please input user mobile',
    search_products: 'Search Products',
    product_details: 'Product Details',
    recipient_info: 'Recipient Info',
    recipient_name: 'Recipient Name',
    recipient_mobile: 'Recipient Mobile',
    please_input_user_mobile: 'Please input user mobile',
    search_failed: 'Search failed',
  },
  es: {
    dashboard: "Tablero",
    layoutBuilder: "Constructor de maquetación",
    craft: "Elaborado",
    pages: "Paginas",
    profile: "Perfil",
    profileOverview: "Descripción general",
    projects: "Proyectos",
    campaigns: "Campañas",
    documents: "Documentos",
    connections: "Conexiones",
    wizards: "Magos",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Cuenta",
    accountOverview: "Descripción general",
    settings: "Ajustes",
    authentication: "Autenticación",
    basicFlow: "Flujo básico",
    signIn: "Registrarse",
    signUp: "Inscribirse",
    passwordReset: "Restablecimiento de contraseña",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Aplicaciones",
    chat: "Chat",
    privateChat: "Chat privado",
    groupChat: "Grupo de chat",
    drawerChat: "Chat del cajón",
    widgets: "Widgets",
    widgetsLists: "Liza",
    widgetsStatistics: "Estadísticas",
    widgetsCharts: "Gráficos",
    widgetsMixed: "Mezclada",
    widgetsTables: "Mesas",
    widgetsFeeds: "Alimenta",
    changelog: "Registro de cambios",
    docsAndComponents: "Documentos & Componentes",
    megaMenu: "Mega menú",
    exampleLink: "Enlace de ejemplo",
    modals: "Modales",
    general: "General",
    inviteFriends: "Invitar A Amigos",
    viewUsers: "Ver Usuarios",
    upgradePlan: "Plan De Actualización",
    shareAndEarn: "Compartir Y Ganar",
    forms: "Formas",
    newTarget: "Nuevo Objetivo",
    newCard: "Nueva Tarjeta",
    newAddress: "Nueva Direccion",
    createAPIKey: "Crea Clave De Api",
    twoFactorAuth: "Dos Factores",
    createApp: "Crear Aplicacion",
    createAccount: "Crear Una Cuenta",
    activity: "Actividad",
    documentation: "Documentación",
    components: "Componentes",
    resources: "Recursos",
    customers: "Clientes",
    gettingStarted: "Empezando",
    customersListing: "Listado De Clientes",
    customerDetails: "Detalles De Los Clientes",
    calendarApp: "Calendario",
    subscriptions: "Suscripciones",
    getStarted: "Empezando",
    subscriptionList: "Lista De Suscripción",
    addSubscription: "Añadir Suscripción",
    viewSubscription: "Suscripción",
  },
  de: {
    dashboard: "Instrumententafel",
    layoutBuilder: "Layout-Builder",
    craft: "Hergestellt",
    pages: "Seiten",
    profile: "Profil",
    profileOverview: "Überblick",
    projects: "Projekte",
    campaigns: "Kampagnen",
    documents: "Unterlagen",
    connections: "Anschlüsse",
    wizards: "Zauberer",
    horizontal: "Horizontal",
    vertical: "Vertikal",
    account: "Konto",
    accountOverview: "Überblick",
    settings: "Die Einstellungen",
    authentication: "Authentifizierung",
    basicFlow: "Grundfluss",
    signIn: "Einloggen",
    signUp: "Anmelden",
    passwordReset: "Passwort zurücksetzen",
    error404: "Fehler 404",
    error500: "Fehler 500",
    apps: "Apps",
    chat: "Plaudern",
    privateChat: "Private Chat",
    groupChat: "Privater Chat",
    drawerChat: "Gruppenchat Schubladen-Chat",
    widgets: "Widgets",
    widgetsLists: "Listen",
    widgetsStatistics: "Statistiken",
    widgetsCharts: "Diagramme",
    widgetsMixed: "Gemischt",
    widgetsTables: "Tabellen",
    widgetsFeeds: "Einspeisungen",
    changelog: "Änderungsprotokoll",
    docsAndComponents: "Dokumente & Komponenten",
    megaMenu: "Mega-Menü",
    exampleLink: "Beispiellink",
    modals: "Modale",
    general: "Allgemeines",
    inviteFriends: "Freunde Einladen",
    viewUsers: "Benutzer Anzeigen.",
    upgradePlan: "Upgrade-Plan",
    shareAndEarn: "Teilen & Verdienen",
    forms: "Formen",
    newTarget: "Neues Ziel",
    newCard: "Neue Karte",
    newAddress: "Neue Adresse",
    createAPIKey: "Api-Key Erstellen",
    twoFactorAuth: "Zwei Faktor Auth.",
    createApp: "App Erstellen",
    createAccount: "Benutzerkonto Erstellen",
    activity: "Aktivität",
    documentation: "Dokumentation",
    components: "Bauteile",
    resources: "Ressourcen",
    customers: "Kunden",
    gettingStarted: "Einstieg",
    customersListing: "Kundenauflistung",
    customerDetails: "Kundenangaben",
    calendarApp: "Kalender",
    subscriptions: "Abonnements",
    getStarted: "Einstieg",
    subscriptionList: "Abonnementliste",
    addSubscription: "Subskription Hinzufügen.",
    viewSubscription: "Abonnement Anzeigen.",
  },
  ja: {
    dashboard: "ダッシュボード",
    layoutBuilder: "レイアウトビルダー",
    craft: "作成された",
    pages: "ページ",
    profile: "プロフィール",
    profileOverview: "概要",
    projects: "プロジェクト",
    campaigns: "キャンペーン",
    documents: "書類",
    connections: "接続",
    wizards: "ウィザード",
    horizontal: "横",
    vertical: "垂直",
    account: "アカウント",
    accountOverview: "概要",
    settings: "設定",
    authentication: "認証",
    basicFlow: "基本的な流れ",
    signIn: "サイン",
    signUp: "インアップ",
    passwordReset: "パスワードのリセット",
    error404: "エラー404",
    error500: "エラー 500",
    apps: "アプリ",
    chat: "チャット",
    privateChat: "プライベートチャット",
    groupChat: "グループチャット",
    drawerChat: "ドロワーチャット",
    widgets: "ウィジェット",
    widgetsLists: "リスト",
    widgetsStatistics: "統計",
    widgetsCharts: "チャート",
    widgetsMixed: "混合",
    widgetsTables: "テーブル",
    widgetsFeeds: "フィード",
    changelog: "変更ログ",
    docsAndComponents: "ドキュメントとコンポーネント",
    megaMenu: "メガメニュー",
    exampleLink: "リンク例",
    modals: "モーダルズ",
    general: "一般",
    inviteFriends: "友達を招待",
    viewUsers: "ユーザーを表示します",
    upgradePlan: "アップグレードプラン",
    shareAndEarn: "シェア＆稼働",
    forms: "フォーム",
    newTarget: "新しいターゲット",
    newCard: "新しいカード",
    newAddress: "新しいアドス",
    createAPIKey: "Apiキーを作成します",
    twoFactorAuth: "2つの要因Auth",
    createApp: "アプリを作成します",
    createAccount: "アカウントを作する",
    activity: "アクティビティ",
    documentation: "ドキュメンテーション",
    components: "コンポーネント",
    resources: "資力",
    customers: "お客様のお客様",
    gettingStarted: "入門",
    customersListing: "顧客のリスト",
    customerDetails: "お客様の詳細",
    calendarApp: "カレンダー",
    subscriptions: "購読",
    getStarted: "入門",
    subscriptionList: "サブスクリプションリスト",
    addSubscription: "サブスクリプションを追加します",
    viewSubscription: "購読を見る",
  },
  fr: {
    dashboard: "Générateur de mise",
    layoutBuilder: "En page",
    craft: "Fabriqué",
    pages: "Pages",
    profile: "Profil",
    profileOverview: "Aperçu",
    projects: "Projets",
    campaigns: "Campagnes",
    documents: "Documents",
    connections: "Connexions",
    wizards: "Sorciers",
    horizontal: "Horizontal",
    vertical: "Verticale",
    account: "Compte",
    accountOverview: "Aperçu",
    settings: "Paramètres",
    authentication: "Authentification",
    basicFlow: "Flux de base",
    signIn: "SS'identifier",
    signUp: "Inscrivez-vous",
    passwordReset: "Réinitialisation du mot de passe",
    error404: "Erreur 404",
    error500: "Erreur 500",
    apps: "Applications",
    chat: "Discuter",
    privateChat: "Discussion privée",
    groupChat: "Discussion de groupe",
    drawerChat: "Chat de tiroir",
    widgets: "Widgets",
    widgetsLists: "Listes",
    widgetsStatistics: "Statistiques",
    widgetsCharts: "Graphiques",
    widgetsMixed: "Mixte",
    widgetsTables: "Les tables",
    widgetsFeeds: "Flux",
    changelog: "Journal des modifications",
    docsAndComponents: "Documents & composants",
    megaMenu: "Méga Menu",
    exampleLink: "Exemple de lien",
    modals: "Modals",
    general: "Général",
    inviteFriends: "Inviter Des Amis",
    viewUsers: "Voir Les Utilisateurs",
    upgradePlan: "Plan De Mise À Niveau",
    shareAndEarn: "Partager Et Gagner",
    forms: "Formes",
    newTarget: "Nouvelle Cible",
    newCard: "Nouvelle Carte",
    newAddress: "Nouvelle Adresse",
    createAPIKey: "Créer Une Touche Api",
    twoFactorAuth: "Deux Facteurs D'Authentification",
    createApp: "Créer Une Application",
    createAccount: "Créer Un Compte",
    activity: "Activité",
    documentation: "Documentation",
    components: "Composants",
    resources: "Ressources",
    customers: "Les Clients",
    gettingStarted: "Commencer",
    customersListing: "Liste Des Clients",
    customerDetails: "Détails Des Clients",
    calendarApp: "Calendrier",
    subscriptions: "Abonnements",
    getStarted: "Commencer",
    subscriptionList: "Liste D'Abonnement",
    addSubscription: "Ajouter Un Abonnement",
    viewSubscription: "Voir L'Abonnement",
  },
};

const i18n = createI18n({
  legacy: false,
  locale: "cn",
  globalInjection: true,
  messages,
});

export default i18n;
